import { Card, CardHeader } from '@material-ui/core';
import React, { FunctionComponent, ReactNode, useEffect, useMemo, useRef, useState } from 'react';
import moment from 'moment';
import { MTableToolbar } from 'material-table';


import Tabla, { Column } from '@infotrack/presentacion-componentes/tabla';
import Texto from '@infotrack/presentacion-componentes/texto';

import IDocumentoDetalleConsultaGeneral from 'Infotrack@Modelos/negocioRefactor/entidades/consulta/IDocumentoDetalleConsultaGeneral';
import IBodegaDivisiones from 'Infotrack@Modelos/smartStock/bodegasDivisiones/entidades/bodegasDivisiones';

interface IEntidadesTablaDetallesPlantilla {
    divisionesOrigen: IBodegaDivisiones[];
    divisionesDestino: IBodegaDivisiones[];
}

interface ITablaDetallesPlantillaProps {
    titulo: ReactNode;
    documentoId: string;
    consultarDetallesDocumento: (documentoId: string) => Promise<IDocumentoDetalleConsultaGeneral[]>,
}

const TablaDetallesPlantilla: FunctionComponent<ITablaDetallesPlantillaProps> = ({
    titulo,
    documentoId,
    consultarDetallesDocumento
}) => {
    const [detalles, setDetalles] = useState<IDocumentoDetalleConsultaGeneral[]>([]);
    useEffect(() => {
        const fetchDetalles = async () => {
            const detalles = await consultarDetallesDocumento(documentoId);
            setDetalles(detalles);
        };
        fetchDetalles();
    }, [documentoId]);



    const obtenerColumnas = () => {
        const columnas: Array<Column<IDocumentoDetalleConsultaGeneral>> = [];
        columnas.push({
            field: 'CodigoEmpresa',
            title: <Texto id="TablaDetallesPlantilla.CodigoEmpresa" />,
        });
        columnas.push({
            field: 'DescripcionItem',
            title: <Texto id="TablaDetallesPlantilla.DescripcionItem" />,
        });


        columnas.push({
            field: 'DescripcionDivisionDestino',
            title: <Texto id="TablaDetallesPlantilla.DivisionDestino" />,
        });

        columnas.push({
            field: 'Serial',
            title: <Texto id="TablaDetallesPlantilla.Serial" />,
        });
        columnas.push({

            field: 'Lote',
            title: <Texto id="TablaDetallesPlantilla.Lote" />,
        });
        columnas.push({
            field: 'FechaIngreso',
            title: <Texto id="TablaDetallesPlantilla.FechaIngreso" />,
            render: (rowData) =>
                rowData.FechaIngreso ? moment(rowData.FechaIngreso).format('DD/MM/YYYY/hh:mm A') : '',
        });
        columnas.push({
            field: 'FechaVencimiento',
            title: <Texto id="TablaDetallesPlantilla.FechaVencimiento" />,
            render: (rowData) =>
                rowData.FechaVencimiento ? moment(rowData.FechaVencimiento).format('DD/MM/YYYY/hh:mm A') : '',
        });
        columnas.push({
            field: 'PesoFraccionRecibido',
            title: <Texto id="TablaDetallesPlantilla.PesoFraccionRecibido" />,
        });

        columnas.push({
            field: 'CantidadRecibida',
            title: <Texto id="TablaDetallesPlantilla.CantidadRecibida" />,
        });
        return columnas;
    };



    return (
        <>
            <Card variant="outlined" style={{ padding: '0px', marginLeft: '20px' }}>
                <CardHeader
                    title={titulo}
                    titleTypographyProps={{ variant: 'body1' }}
                    style={{ padding: '0px', minHeight: '0px' }}
                />
                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <Tabla
                        components={{
                            Toolbar: (props) => (
                                <div style={{ padding: '0px', height: '0px' }}>
                                    <MTableToolbar {...props} />
                                </div>
                            ),
                        }}
                        onTreeExpandChange={() => { }}
                        columns={obtenerColumnas()}
                        data={detalles}
                        options={{ padding: 'dense', search: true }}
                    />
                </div>
            </Card>

        </>
    );
};

export { IEntidadesTablaDetallesPlantilla };

export default TablaDetallesPlantilla;
